<template>
  <div class="app-login">
    <form class="app-login-form" @submit.prevent="aceptar">
      <img class="app-login-logo" src="../assets/img/logo_white.png" alt="Eurocaja Rural"/>
      <h4 class="app-login-title">Portal de Proveedores de Confirming</h4>
      <div class="form-group">
        <div class="mensajeConfirmacionReducido" v-if="confirmacion=='OK'">
          <p>check_circle</p>
          <h3>Le hemos enviado un correo electrónico para realizar su recuperación de contraseña.</h3>
       </div>
        <div class="mensajeErrorReducido" v-if="confirmacion=='KO'">
          <p>warning</p>
          <h3>{{mensajeError}}</h3>
        </div>
        <span class="app-firstLogin-information">Si ha olvidado su contraseña, introduzca los siguientes datos de su apoderado 
          y pulse 'Entrar', contactaremos con usted con la información necesaria para que pueda recuperar su contraseña.</span>
        <input class="inputLoginComponent" type="text" name="documentId" placeholder="NIF/NIE *" v-model="model.identification" required/>
        <input :class="(submitted && $v.model.phoneNumber.$invalid)?'inputLoginInvalid ':'inputLoginComponent'" type="text" name="telefono" maxlength="9" placeholder="Teléfono móvil *" v-model="model.phoneNumber" required/>
        <!-- Posibles errores de validacion -->
        <div class="error" v-if="submitted && (!$v.model.phoneNumber.minLength)">Introduzca un número de teléfono válido</div>
        <br/>
          <div class="firmaconLogin" v-if=datosFirma>
              <SignatureComponent :params="params" :datosFirma="datosFirma" :llamada="llamada" @aceptar="callBackAceptar" @cancelar="callBackCancelar"></SignatureComponent>
          </div>
              <div v-if=datosOTP>
                <OTPComponent :params="params" :datosOTP="datosOTP" :llamada="llamada" @aceptar="callBackAceptarOTP" @cancelar="callBackCancelarOTP"></OTPComponent>
              </div>
        <input class="btnPrimary" type="submit" value="Aceptar" :disabled="isDisabled" v-if=beforeSubmit>
        <input class="btnSecondary" type="button" value="Volver" @click="volver" v-if="confirmacion=='OK'">
        <div class="app-login-disclaimer">
          <div class="icon-lock">
            
          </div>
          <p>
              Recomendaciones de Seguridad:
              <br/>
              <br/>
              Mantén tus claves en secreto y cámbialas regularmente.
              <br/>
              No introduzcas la Clave de Firma para consulta de saldo, movimientos, o sin haber iniciado ninguna operación.
              <br/>
              No olvides pulsar salir al terminar tu sesión.
              <br/>
              Nunca te solicitaremos tus claves personales y confidenciales por teléfono, correo electrónico o fax, ni te pediremos que realices ninguna prueba de operaciones en tu oficina digital.
              <br/>
              <br/>
              Si tienes dudas, llama a nuestro servicio de Atención al cliente 925 26 96 44.
          </p>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import ForgotPassword from '../models/ForgotPassword';
import { minLength } from "vuelidate/lib/validators";
import SignatureComponent from './SignatureComponent';
import OTPComponent from './OTPComponent';
export default {
  name: "ForgotPasswordComponent",
  data() {
    return {
      model : new ForgotPassword(null,'01',null,'E'), //pongo los campos por defecto identificacion NIF/CIF y modo de Notificacion por correo
      datosFirma: null,
      datosOTP: null,
      params:null,
      llamada:null,
      confirmacion:null,
      mensajeError:'Algo ha ido mal, asegúrate que has introducido correctamente tus datos', //mensaje de error por defecto
        beforeSubmit:true, //este submit es para la clave de firma
        submitted:false //este es para las validaciones
    }
  },
    components: {
      SignatureComponent,
      OTPComponent
    },
    validations : { //aqui ponemos la validacion de cada input del html
      model:{
        phoneNumber:{
          minLength:minLength(9)
        }
      }
    },
  computed : {
    isDisabled: function() {
        return !this.model.identification || !this.model.phoneNumber;
    }
  },
  methods : {
    aceptar() {
      this.submitted = true;
          this.$v.$touch();
          if(this.$v.$invalid) {
            return false;
          }else {
             const ventana=this;
            const baseURI = '/api-users/users/forgotPasswordProviderPortal';
            const options = {
                  headers: {
                    'X-CHANNEL-KEY':'W'
                  }
                };
            this.params =this.model;
            let loader = this.$loading.show();
            this.llamada = {
                      urlEndpoint : baseURI,
                      metodo : 'PUT',
                      canal:options.headers['X-CHANNEL-KEY'] //si el canal utilizado es W, en la OTP tambien
                    };
            this.$http.put(baseURI, this.params, options)
            .then(() => {
              ventana.confirmacion='OK';
              ventana.beforeSubmit=false;
            })
            .catch(function (error) {
                  if(error.response){ 
                      if(error.response.status == 400) {
                        if(error.response.data.result.errors[0].errorCode == "096H") {
                          if(error.response.data.result.errors[0].info.type=="OTP"){ //pide pin de OTP
                            ventana.datosOTP = error.response.data.result.errors[0].info;
                          }else{ //pide clave de firma
                            ventana.datosFirma = error.response.data.result.errors[0].info;
                          }
                          ventana.beforeSubmit = false;
                        }else{
                          if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                            ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                          }else{ //si no, por defecto
                            ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                          }
                          ventana.confirmacion='KO';
                          ventana.beforeSubmit=true;
                          window.scroll({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                          });
                        }
                      }else{
                        if(error.response.status=='404'){ //error de conexion o ruta incorrecta
                          ventana.mensajeError='No se ha podido establecer conexión con el servidor';
                        }else{
                          if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                            ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                          }else{ //si no, por defecto
                            ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                          }
                        }
                        ventana.confirmacion='KO';
                        ventana.beforeSubmit=true;
                        window.scroll({
                          top: 0,
                          left: 0,
                          behavior: 'smooth'
                        });
                      }
              }
            })
            .then(function () {
              loader.hide();
            });
          }
    },
    
      callBackAceptarOTP(confirmacion, mensaje, codError){
        this.beforeSubmit = false;
        this.confirmacion = confirmacion;
        this.submitted=false;
        this.mensajeError = mensaje;
        if(confirmacion == "OK") {
          this.callBackCancelarOTP(); //son las instrucciones necesarias para resetear la pantalla como al comienzo
          window.scroll({
              top: 0,
              left: 0,
              behavior: 'smooth'
          });
        } else {
          window.scroll({
              top: 470,
              left: 0,
              behavior: 'smooth'
          });
          if(codError == '095H') { //clave otp incorrecta
          }else if (codError == '089H') {
            this.datosOTP = null;
            this.mensajeError = 'Usuario bloqueado';
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
          }else{ //si es un error distinto del bloqueo de usuario o clave otp incorrecta, la otp se comporta como si la cancelaramos
            this.callBackCancelarOTP();
          }
        }
      },
     callBackCancelarOTP(){
         this.beforeSubmit = true;
         this.submitted=false;
         this.datosOTP = null;
      },
      callBackAceptar(confirmacion, result,otp){
        this.beforeSubmit = false;
        this.datosFirma = null;
        this.datosOTP=otp;
      },
     callBackCancelar(){
         this.beforeSubmit = true;
         this.datosFirma = null;
      },
      volver(){
        this.$router.push('/identificacion');
      }
  }
}
</script>